import React from 'react';
import './Card.css';

/**
 * Tennis Diary UI Kit — Card
 *
 * Composition:
 *   <Card>
 *     <CardHeader title="Last Trainings" subtitle="Past 7 days" actions={<Button…/>} />
 *     <CardBody>…</CardBody>
 *     <CardFooter>…</CardFooter>
 *   </Card>
 *
 * `<Card variant="flat">` removes shadow.
 * `<Card interactive>` adds hover lift (use only when whole card is clickable).
 */
export const Card = React.forwardRef(function Card(
  { children, variant = 'default', interactive = false, className = '', ...rest },
  ref,
) {
  const classes = [
    'tdk-card',
    variant === 'flat' ? 'tdk-card--flat' : '',
    variant === 'ghost' ? 'tdk-card--ghost' : '',
    interactive ? 'tdk-card--interactive' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div ref={ref} className={classes} {...rest}>
      {children}
    </div>
  );
});

export const CardHeader = ({ title, subtitle, actions, children, className = '', ...rest }) => (
  <div className={`tdk-card__header ${className}`} {...rest}>
    <div>
      {title && <h3 className="tdk-card__title">{title}</h3>}
      {subtitle && <p className="tdk-card__subtitle">{subtitle}</p>}
      {children}
    </div>
    {actions && <div className="tdk-card__actions">{actions}</div>}
  </div>
);

export const CardBody = ({ children, density = 'normal', className = '', ...rest }) => {
  const cls = [
    'tdk-card__body',
    density === 'tight' ? 'tdk-card__body--tight' : '',
    density === 'flush' ? 'tdk-card__body--flush' : '',
    className,
  ].filter(Boolean).join(' ');
  return <div className={cls} {...rest}>{children}</div>;
};

export const CardFooter = ({ children, className = '', ...rest }) => (
  <div className={`tdk-card__footer ${className}`} {...rest}>{children}</div>
);

export default Card;
